import { ExportTypeBaseService } from '/@/modules/export/services/ExportTypeBaseService';
import { getters } from '/@/modules/core/app/helpers/store';
import Lang from '/@/modules/core/app/services/Lang';

export class EstateClearEstateExportService extends ExportTypeBaseService {
  /**
   * @var {Estate}
   */
  estate;

  /**
   * @return {string}
   */
  getFilename() {
    this.estate = getters.export.getData().estate;
    return `${this.estate.contact.fullName.replaceAll(' ', '-')}-clearestate-summary.pdf`;
  }

  /**
   * @return {*}
   */
  getSnackBarTitle() {
    this.estate = getters.export.getData().estate;
    return Lang.t("estate.settlement-summary-exporting", {
      name: this.estate.contact.fullName
    });
  }
}

export default new EstateClearEstateExportService();
